import React from 'react'
import { Box, Flex, Skeleton } from '@chakra-ui/core'
import { Button } from 'components/ui'
import { Upload } from 'lucide-react'
import { attachmentMenuText } from 'components/ui/AttachmentMenu/literals'
import { useMediaState } from 'hooks/useMediaState'
import HiddenFileInput from 'components/ui/Input/HiddenFileInput'
import useLocaleText from 'components/useLocaleText'
import strings from 'constants/strings'
import { LinkInputField } from './LinkInputFied'
import { Subtask } from 'components/TasksV2/TaskCreation/FormStepContext'
import { useFormContext } from 'react-hook-form'
import { DropzoneWrapper } from 'components/DropzoneWrapper'
import { useDropzoneHandlers } from 'hooks/useDropzoneHandlers'

interface Props {
  pathName: string
  titleName: string
  field: Subtask
}

export const LinkPath: React.FC<Props> = ({ pathName, titleName, field }) => {
  const { control, setValue, getValues, triggerValidation } = useFormContext()

  const { handleFileUpload, isUploadLoading, fileInputRef } = useMediaState({
    files: [],
  })

  const t_pls_add_link = useLocaleText('t_pls_add_link')
  const t = useLocaleText(attachmentMenuText)

  const handleClickOnAddFile = () => {
    fileInputRef.current?.click()
  }

  const handleLinkSubtaskFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const response = await handleFileUpload(e)
    const fileName = response?.[0]?.fileName
    const fileUrl = response?.[0]?.fileUrl

    if (fileUrl) {
      setValue(pathName, fileUrl)
      triggerValidation(pathName)

      const currentTitle = getValues(titleName)
      if (!currentTitle && fileName) {
        setValue(titleName, fileName)
      }
    }
  }

  const handleUploadMedia = async (files: File[]) => {
    const event = {
      currentTarget: {
        files: [files[0]] as unknown as FileList,
      },
    } as unknown as React.ChangeEvent<HTMLInputElement>

    const response = await handleFileUpload(event)
    const fileName = response?.[0]?.fileName
    const fileUrl = response?.[0]?.fileUrl

    if (fileUrl) {
      setValue(pathName, fileUrl)
      triggerValidation(pathName)

      const currentTitle = getValues(titleName)
      if (!currentTitle && fileName) {
        setValue(titleName, fileName)
      }
    }
  }

  const { onDrop, handlePaste } = useDropzoneHandlers({
    onUploadMedia: handleUploadMedia,
    accept: `${strings.POST_FILE_ACCEPT_EXTENSIONS}`,
  })

  return (
    <DropzoneWrapper onDrop={onDrop} onPaste={handlePaste}>
      {isUploadLoading ? (
        <Skeleton height="30px" borderRadius="10px" mt="5px" />
      ) : (
        <Flex align="flex-start" style={{ gap: 10 }}>
          <Box flex="1" minWidth={0}>
            <LinkInputField
              name={pathName}
              control={control}
              placeholder={t_pls_add_link}
              defaultValue={field?.external_link}
            />
          </Box>
          <Button
            type="button"
            variant="secondary"
            height="40px"
            flexShrink={0}
            startIcon={<Upload size={16} />}
            onClick={handleClickOnAddFile}
          >
            {t.uploadFile}
          </Button>
        </Flex>
      )}
      <HiddenFileInput
        ref={fileInputRef}
        accept={strings.POST_FILE_ACCEPT_EXTENSIONS}
        onChange={handleLinkSubtaskFiles}
      />
    </DropzoneWrapper>
  )
}
